module.exports = __webpack_public_path__ + "static/media/IMG_0047-2.6bae7fcc.jpg";